import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EXERCISE_LOGIC, EXERCISE_TASK, KATEX_FORMAT } from '@app/app.constants';
import { Answer, IExercise } from '@app/definitions/interfaces';

@Component({
    selector: 'app-exercise-task',
    templateUrl: './exercise-task.component.html',
    styleUrls: ['../../../../../_pipes/exercise-format.pipe.scss', './exercise-task.component.scss']
})
export class ExerciseTaskComponent implements OnInit {
    @Input() exercise;
    @Input() cardId: number;
    @Input() studentId: number;
    @Input() exerIndex: number;
    @Input() isAuthorCard: boolean;
    @Input() isAccessCard: boolean;
    @Input() prev_results: Array<any> = [];
    @Output() exerciseCorrect = new EventEmitter();
    @Output() answers = new EventEmitter();

    questionAnswers: Answer[] = [];
    exerciseAnsweredCorrectly: boolean = true;

    public task = EXERCISE_TASK;
    public logic = EXERCISE_LOGIC;

    constructor() {}

    ngOnInit() {
        // console.log(this.exercise);
        for (const answ of this.exercise.answers) {
            const answer: Answer = {
                student: this.studentId,
                fullAnswer: answ.fullAnswer,
                card: this.cardId,
                shortAnswer: answ.shortAnswer,
                exercise: this.exercise.id,
                correct: true,
                question: answ.question
            };

            this.questionAnswers.push(answer);
        }
    }

    questionAnswered(event) {
        for (const answer of this.questionAnswers) {
            if (answer.question === event.question) {
                answer.shortAnswer = event.shortAnswer;
                answer.fullAnswer = event.fullAnswer;
                answer.correct = event.correct;
            }
        }
        let correctCount: number = 0;
        for (const answer of this.questionAnswers) {
            if (answer.correct) {
                correctCount++;
            }
        }
        if (correctCount !== this.exercise.questions.length) {
            this.exerciseAnsweredCorrectly = false;
        }
        this.exerciseCorrect.emit(this.exerciseAnsweredCorrectly);
        this.answers.emit(this.questionAnswers);
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }
}
